// Pashto translations
export const ps: Record<string, string> = {'menu.dashboard':'ډيش بورډ','menu.customers':'پيرودونکي','menu.products':'محصولات','menu.users':'کارونکي','menu.settings':'تنظيمات','menu.logout':'وتل','dashboard.title':'ډيش بورډ','dashboard.newOrder':'نوی امر','order.title':'نوی امر','order.customer':'پيرودونکی','order.products':'محصولات','order.total':'ټولټال','users.title':'کارونکي','users.name':'نوم','users.email':'بريښناليک','common.yes':'هو','common.no':'نه','common.cancel':'لغوه کول','common.save':'خوندي کول','common.search':'لټون','login.title':'Cleandy','login.login':'ننوتل','login.welcome':'ښه راغلاست، {name}',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.','signup.email':'بريښناليک','signup.phone':'تليفون',
  'menu.reportsAndAccounting': 'راپورونه او محاسبه',
  'menu.systemAndCommunication': 'سیسټم او اړیکې',
};
